
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import CartListSection from '@Components/CartPage/CartListSection';
import { Amount, CartHeader, GrayTitle, Icon, Title } from '@Components/CartPage/CartPage.styled';
import { Spinner } from '@Components/common/Spinner';
import FeatureCard from '@Components/FeatureCard';
import Layout from '@Components/Layout';
import { NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import CartIcon from 'public/gray-cart.svg';
import DeliveryIcon from 'public/sell-icons/delivery.svg';
import DollarIcon from 'public/sell-icons/dollar.svg';
import GuarenteeIcon from 'public/sell-icons/guarentee.svg';
import WrenchIcon from 'public/sell-icons/wrench.svg';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Col, Container, Row } from 'styled-bootstrap-grid';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

type Props = {};

const Cart: NextPage<Props> = () => {
  const { t } = useTranslation('Cart');
  const { t: tCommon } = useTranslation('common');
  const { data: cartData, firstIsLoading: isGlobalLoading } = useSelector((state: RootState) => state.cart);

  return (
    <Layout seoData={{ title: 'Cart' }} noFollow={true}>
      <Container>
        <Row>
          <Col col={12}>
            <CartHeader>
              <Icon>
                <Image src={CartIcon} width={24} height={21.65} alt="cart" />
              </Icon>
              <Title>{t('cart_label')}</Title>
              {!isGlobalLoading ? (
                Boolean(cartData?.items?.length) && (
                  <Amount>
                    ({cartData?.items.length} {t('orders')})
                  </Amount>
                )
              ) : (
                <Spinner />
              )}
            </CartHeader>
          </Col>
          {!isGlobalLoading && (
            <Fragment>
              <Col col={12} lg={8}>
                {Boolean(cartData?.items?.length) ? <CartListSection /> : <div>Your cart is empty</div>}
              </Col>
              <Col
                col={12}
                lg={4}
                style={{
                  marginBottom: 40,
                }}
              >
                {/* <AsideHeader>
                  <AsideTitle>{t('related_products')}</AsideTitle>
                  <AddBtn>+ {t('add_product')}</AddBtn>
                </AsideHeader>
                <Swiper modules={[Pagination, FreeMode]} pagination={true} spaceBetween={8} slidesPerView={1}>
                  <SwiperSlide>
                    <RelatedProduct />
                    <RelatedProduct />
                  </SwiperSlide>
                  <SwiperSlide>
                    <RelatedProduct />
                    <RelatedProduct />
                  </SwiperSlide>
                  <SwiperSlide>
                    <RelatedProduct />
                    <RelatedProduct />
                  </SwiperSlide>
                  <SwiperSlide>
                    <RelatedProduct />
                    <RelatedProduct />
                  </SwiperSlide>
                  <SwiperSlide>
                    <RelatedProduct />
                    <RelatedProduct />
                  </SwiperSlide>
                </Swiper> */}
                <GrayTitle>{t('enjoy_feature')}</GrayTitle>
                <FeatureCard
                  data={{
                    title: tCommon('sell-slogan-1'),
                    img: GuarenteeIcon,
                  }}
                />
                <FeatureCard
                  data={{
                    title: tCommon('sell-slogan-2'),
                    img: DeliveryIcon,
                  }}
                />
                <FeatureCard
                  data={{
                    title: tCommon('sell-slogan-3'),
                    img: DollarIcon,
                  }}
                />
                <FeatureCard
                  data={{
                    title: tCommon('sell-slogan-4'),
                    img: WrenchIcon,
                  }}
                />
              </Col>
            </Fragment>
          )}
        </Row>
      </Container>
    </Layout>
  );
};

const __Page_Next_Translate__ = Cart;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: false,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  